import { UploadedFile } from '../files/UploadedFile';
import { ComponentFileCollection, FileProcessingResult, MiscellaneousFileCollection } from '../types';

export function preloadFileProcessingResult(files: FileProcessingResult) {
  return resolveWhenComplete(preloadComponentFiles(files.componentDesigns), preloadMiscFiles(files.miscellaneousFiles));
}

export function preloadComponentFiles(collection: ComponentFileCollection) {
  return resolveWhenComplete(...Object.values(collection).map(preloadFiles));
}

export function preloadMiscFiles(collection: MiscellaneousFileCollection) {
  return resolveWhenComplete(preloadFiles(Object.values(collection)));
}

export function preloadFiles(files: readonly UploadedFile[]) {
  return resolveWhenComplete(...files.map((file) => file.getContents()));
}

function resolveWhenComplete(...promises: Promise<any>[]) {
  return Promise.all(promises).then(() => {});
}
